import { type RefObject, useEffect } from 'react';
import type { Chart } from 'primereact/chart';

/**
 * Chart.js (via PrimeReact) often keeps the canvas at the width from first paint.
 * Observing the panel + window resize forces chart.resize() so the plot fills the card after layout changes.
 */
export function usePrimeChartPanelResize(
  panelRef: RefObject<HTMLElement | null>,
  chartRef: RefObject<Chart | null>,
  enabled: boolean,
  layoutKey: string
) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const resize = () => {
      const chart = chartRef.current?.getChart?.();
      if (chart && typeof chart.resize === 'function') {
        chart.resize();
      }
    };

    const panel = panelRef.current;
    const ro = new ResizeObserver(() => {
      requestAnimationFrame(resize);
    });

    if (panel) {
      ro.observe(panel);
    }

    window.addEventListener('resize', resize);
    requestAnimationFrame(resize);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', resize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, layoutKey]);
}
